module.exports = __webpack_public_path__ + "static/media/das-dlr-video-fallback.27e6fb73.jpg";